<template>
  <div class="cell small-12 medium-10">
    <div class="grid-x">
      <div class="cell small-6 medium-4">
        <Skeleton height="40px" />
      </div>
      <div class="cell medium-12 padding-bottom-s">
        <Skeleton height="80px" />
      </div>
    </div>
    <div class="grid-x">
      <div class="cell medium-12">
        <Skeleton height="200px" />
      </div>
      <div class="cell small-6 medium-3 padding-bottom-xs">
        <Skeleton height="80px" />
      </div>
    </div>
    <div class="grid-x grid-padding-y">
      <div v-for="index in 3" :key="index" class="cell">
        <Skeleton height="150px" />
      </div>
    </div>
  </div>
</template>

<script setup>
import Skeleton from '@nuxt-common/atomic-ui/app/components/skeleton/Skeleton.vue';
</script>
